import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=3d8a2902&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=3d8a2902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a2902",
  null
  
)

export default component.exports